import { createFileRoute } from '@tanstack/react-router';
import { ContainerTypeLegacy, DevicesLayout, navigateToError } from '@amber-ui/core';

function DevicesRoute() {
  const { bin } = Route.useSearch();

  if (!bin) return null;

  return (
    <DevicesLayout
      container_id={bin}
      container_type={ContainerTypeLegacy.bin}
      onError={() => {
        navigateToError();
      }}
      onHubAssignmentSuccess={() => {}}
      onAssignFanControllerSuccess={() => {}}
      onUnassignFanControllerSuccess={() => {}}
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/devices')({
  component: DevicesRoute,
});
